import type { PluginOptions } from 'vue-toastification'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin(({ vueApp }) => {
  const options: PluginOptions = {
    position: POSITION.TOP_RIGHT,
    timeout: 3000,
    closeOnClick: true,
    maxToasts: 5,
    newestOnTop: true,
    pauseOnHover: true,
  }

  vueApp.use(Toast, options)
})
